'use strict';

exports.__esModule = true;

var _BaseAnalyticsDataHandler = require('./BaseAnalyticsDataHandler');

var _BaseAnalyticsDataHandler2 = _interopRequireDefault(_BaseAnalyticsDataHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Analytics Manager
 *
 * CONVENTIONS:
 * - Always use "track" as the function prefix/verb.
 * - We're preferring a payload with "named arguments", using object destructuring within the function to show these explicitly like arguments.
 * - We prefer that the aggregate data needed by ALL analytics providers be known and properly typed using Flow at the time that the
 * AnalyticsManager methods are called. Because AnalyticsManager is an abstraction that distributes data to several different providers, it
 * needs to have a complete picture of what all the data is. We already did this previously, but we didn't carefully define it and instead
 * passed it as a generic "payload". Once we can examine the purchase action and hopefully come up with an abstract Bag input, we can more heavily
 * type that and control more of its provider distribution from common-web.
 */
var AnalyticsManager =

/**
 * Alternate pattern - more concise but doesn't allow us as much flexibility to do typing with Flow
 * constructor() {
 *   [
 *       'checkoutStep',
 *       'checkoutOption',
 *   ]
 *   .forEach(name => {
 *       const fullName = `track${upperFirst(name)}`;
 *       this[fullName] = (...args) => {
 *           this.dataHandlers && this.dataHandlers.forEach(dataHandler => dataHandler[fullName](...args));
 *       }
 *   });
 * }
 */

function AnalyticsManager(DataHandlers) {
    var _this = this;

    _classCallCheck(this, AnalyticsManager);

    this._passDataToDataHandlers = function (methodName) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        if (_this.dataHandlers && _this[methodName] && _BaseAnalyticsDataHandler2.default.prototype[methodName]) {
            _this.dataHandlers.forEach(function (dataHandler) {
                return dataHandler[methodName].apply(dataHandler, args);
            });
        } else {
            console.error(methodName + ' is not implemented on either AnalyticsManager or the BaseAnalyticsDataHandler');
        }
    };

    this.trackCheckoutStep = function (params) {
        return _this._passDataToDataHandlers('trackCheckoutStep', params);
    };

    this.trackCheckoutOption = function (params) {
        return _this._passDataToDataHandlers('trackCheckoutOption', params);
    };

    this.trackPurchase = function (payload) {
        return _this._passDataToDataHandlers('trackPurchase', payload);
    };

    this.sendPurchaseEvent = function (payload) {
        return _this._passDataToDataHandlers('sendPurchaseEvent', payload);
    };

    this.trackManualOfferRedemption = function (params) {
        return _this._passDataToDataHandlers('trackManualOfferRedemption', params);
    };

    this.trackDigitalOfferRedemption = function (params) {
        return _this._passDataToDataHandlers('trackDigitalOfferRedemption', params);
    };

    // registers data handlers, each of which inherits from the super class baseDataHandler which defines the public API
    this.dataHandlers = DataHandlers.map(function (DataHandler) {
        return new DataHandler();
    });
}

// not typed - needs to be rethought (separate implementations in both DataHandler and Purchase)


// REMOVE after all dependent sites are updated to utilize the latest refactor - here for backwards compatibility
;

exports.default = AnalyticsManager;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/AnalyticsManager/AnalyticsManager.js
// module id = 852
// module chunks = 0